const OFFICIAL_SOURCES = [
  {
    label: "SGK işveren prim oranları",
    url: "https://www.sgk.gov.tr/Content/Post/c7812ea8-5087-413f-aeb5-d3c1d153e11a/Isveren-Prim-Oranlari-2026-01-13-04-52-38"
  },
  {
    label: "SGK güncel teşvik ve indirimleri",
    url: "https://www.sgk.gov.tr/Content/Post/c52f99f0-da6c-4029-9b9a-a0d6f96a6a42/Guncel-Sigorta-Primi-Tesvik-Destek-ve-Indirimleri-2026-08-04-10-29-55"
  },
  {
    label: "GİB asgari ücret hesabı",
    url: "https://cdn.gib.gov.tr/api/gibportal-file/file/getFileResources?objectKey=arsiv%2Fyardim-kaynaklar%2Fyararli-bilgiler%2FAsgariUcrettenYapilanKesintiler.pdf"
  },
  {
    label: "GİB 2026 gelir vergisi tarifesi",
    url: "https://cdn.gib.gov.tr/api/gibportal-file/file/getFileResources?objectKey=arsiv%2Fyardim-kaynaklar%2Fyararli-bilgiler%2Fgelir-vergisi-tarifeleri%2Fgelir-vergisi-tarifesi-2026.pdf"
  },
  {
    label: "GİB 4691 ve 5746 ücret teşvikleri",
    url: "https://cdn.gib.gov.tr/api/gibportal-file/file/getFile?objectKey=DUYURU%2FUNIVERSAL%2F2026%2F2026_Ucret_Geliri.pdf"
  }
];

const PAYROLL_RULES = {
  2025: {
    minimumWage: 26005.5,
    socialSecurityCeiling: 195041.4,
    employeeSocialRate: 0.14,
    employeeUnemploymentRate: 0.01,
    employerSocialRate: 0.2075,
    employerUnemploymentRate: 0.02,
    standardDiscountRate: 0.04,
    manufacturingDiscountRate: 0.05,
    stampTaxRate: 0.00759,
    wageTaxBrackets: [
      [158000, 0.15],
      [330000, 0.2],
      [1200000, 0.27],
      [4300000, 0.35],
      [Infinity, 0.4]
    ]
  },
  2026: {
    minimumWage: 33030,
    socialSecurityCeiling: 297270,
    employeeSocialRate: 0.14,
    employeeUnemploymentRate: 0.01,
    employerSocialRate: 0.2175,
    employerUnemploymentRate: 0.02,
    standardDiscountRate: 0.02,
    manufacturingDiscountRate: 0.05,
    stampTaxRate: 0.00759,
    wageTaxBrackets: [
      [190000, 0.15],
      [400000, 0.2],
      [1500000, 0.27],
      [5300000, 0.35],
      [Infinity, 0.4]
    ]
  }
};

const INCENTIVE_OPTIONS = [
  { value: "00000", label: "00000 · Teşviksiz" },
  { value: "05510", label: "05510 · 5510 prim indirimi" },
  { value: "04691", label: "04691 · Teknopark personeli" },
  { value: "05746", label: "05746 · Ar-Ge / tasarım personeli" }
];

const EDUCATION_OPTIONS = [
  { value: "other", label: "Diğer personel", rate: 0.8 },
  { value: "masters", label: "Yüksek lisans / desteklenen alan lisans", rate: 0.9 },
  { value: "doctorate", label: "Doktora / desteklenen alan yüksek lisans", rate: 0.95 }
];

const MONTH_NAMES = [
  "Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran",
  "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"
];

const roundMoney = (value) => Math.round((Number(value) + Number.EPSILON) * 100) / 100;
const clamp = (value, min, max) => Math.min(Math.max(Number(value) || 0, min), max);

function calculateProgressiveTax(base, brackets) {
  let remaining = Math.max(0, Number(base) || 0);
  let previousLimit = 0;
  let tax = 0;

  for (const [limit, rate] of brackets) {
    const taxableInBracket = Math.max(0, Math.min(remaining, limit - previousLimit));
    tax += taxableInBracket * rate;
    remaining -= taxableInBracket;
    previousLimit = limit;
    if (remaining <= 0) break;
  }

  return roundMoney(tax);
}

function calculateMarginalTax(previousBase, currentBase, brackets) {
  return roundMoney(
    calculateProgressiveTax((Number(previousBase) || 0) + (Number(currentBase) || 0), brackets) -
      calculateProgressiveTax(previousBase, brackets)
  );
}

function getEducationRate(value) {
  return EDUCATION_OPTIONS.find((item) => item.value === value)?.rate || 0.8;
}

function calculatePayrollMonth({
  year,
  monthIndex,
  gross,
  code,
  workDays = 30,
  eligibleDays = 30,
  education = "other",
  manufacturing = false,
  previousTaxBase = 0,
  previousMinimumTaxBase = 0
}) {
  const rules = PAYROLL_RULES[year] || PAYROLL_RULES[2026];
  const safeGross = Math.max(0, Number(gross) || 0);
  const safeWorkDays = clamp(workDays, 1, 30);
  const safeEligibleDays = clamp(eligibleDays, 0, safeWorkDays);
  const eligibleRatio = safeEligibleDays / safeWorkDays;
  const monthlyCeiling = rules.socialSecurityCeiling * (safeWorkDays / 30);
  const contributionBase = Math.min(safeGross, monthlyCeiling);
  const employeeSocial = roundMoney(contributionBase * rules.employeeSocialRate);
  const employeeUnemployment = roundMoney(contributionBase * rules.employeeUnemploymentRate);
  const taxBase = roundMoney(Math.max(0, safeGross - employeeSocial - employeeUnemployment));
  const incomeTaxBeforeMinimumExemption = calculateMarginalTax(previousTaxBase, taxBase, rules.wageTaxBrackets);

  const proratedMinimumWage = rules.minimumWage * (safeWorkDays / 30);
  const minimumWageGrossBasis = Math.min(safeGross, proratedMinimumWage);
  const minimumTaxBase = roundMoney(minimumWageGrossBasis * (1 - rules.employeeSocialRate - rules.employeeUnemploymentRate));
  const minimumIncomeTax = calculateMarginalTax(previousMinimumTaxBase, minimumTaxBase, rules.wageTaxBrackets);
  const minimumIncomeTaxExemption = roundMoney(Math.min(incomeTaxBeforeMinimumExemption, minimumIncomeTax));
  const incomeTaxAfterMinimumExemption = roundMoney(
    Math.max(0, incomeTaxBeforeMinimumExemption - minimumIncomeTaxExemption)
  );

  const stampTaxBeforeExemption = roundMoney(safeGross * rules.stampTaxRate);
  const minimumStampTaxExemption = roundMoney(Math.min(safeGross, proratedMinimumWage) * rules.stampTaxRate);
  const stampTaxAfterMinimumExemption = roundMoney(
    Math.max(0, stampTaxBeforeExemption - minimumStampTaxExemption)
  );

  const hasGeneralDiscount = ["05510", "04691", "05746"].includes(code);
  const hasResearchIncentive = ["04691", "05746"].includes(code);
  const discountRate = manufacturing ? rules.manufacturingDiscountRate : rules.standardDiscountRate;
  const generalEmployerDiscount = hasGeneralDiscount
    ? roundMoney(contributionBase * Math.min(discountRate, rules.employerSocialRate))
    : 0;
  const employerSocialBeforeDiscount = roundMoney(contributionBase * rules.employerSocialRate);
  const employerUnemployment = roundMoney(contributionBase * rules.employerUnemploymentRate);
  const researchEmployerSupport = hasResearchIncentive
    ? roundMoney(Math.max(0, employerSocialBeforeDiscount - generalEmployerDiscount) * 0.5 * eligibleRatio)
    : 0;

  const cappedGrossForResearch = Math.min(safeGross, rules.minimumWage * 40);
  const researchCapRatio = safeGross > 0 ? cappedGrossForResearch / safeGross : 0;
  const incomeIncentiveRate = code === "04691" ? 1 : code === "05746" ? getEducationRate(education) : 0;
  const incomeTaxIncentive = hasResearchIncentive
    ? roundMoney(incomeTaxAfterMinimumExemption * eligibleRatio * researchCapRatio * incomeIncentiveRate)
    : 0;
  const stampTaxIncentive = hasResearchIncentive
    ? roundMoney(stampTaxAfterMinimumExemption * eligibleRatio * researchCapRatio)
    : 0;

  const payableIncomeTax = roundMoney(Math.max(0, incomeTaxAfterMinimumExemption - incomeTaxIncentive));
  const payableStampTax = roundMoney(Math.max(0, stampTaxAfterMinimumExemption - stampTaxIncentive));
  const net = roundMoney(safeGross - employeeSocial - employeeUnemployment - payableIncomeTax - payableStampTax);
  const employerPremiumBeforeIncentive = roundMoney(employerSocialBeforeDiscount + employerUnemployment);
  const employerPremiumAfterIncentive = roundMoney(
    Math.max(0, employerPremiumBeforeIncentive - generalEmployerDiscount - researchEmployerSupport)
  );
  const employerCostBeforeIncentive = roundMoney(safeGross + employerPremiumBeforeIncentive);
  const employerCostAfterIncentive = roundMoney(safeGross + employerPremiumAfterIncentive);

  return {
    year,
    monthIndex,
    gross: roundMoney(safeGross),
    workDays: safeWorkDays,
    eligibleDays: safeEligibleDays,
    eligibleRatio,
    contributionBase: roundMoney(contributionBase),
    employeeSocial,
    employeeUnemployment,
    taxBase,
    incomeTaxBeforeMinimumExemption,
    minimumIncomeTaxExemption,
    incomeTaxAfterMinimumExemption,
    incomeTaxIncentive,
    payableIncomeTax,
    stampTaxBeforeExemption,
    minimumStampTaxExemption,
    stampTaxIncentive,
    payableStampTax,
    net,
    employerSocialBeforeDiscount,
    employerUnemployment,
    generalEmployerDiscount,
    researchEmployerSupport,
    employerPremiumBeforeIncentive,
    employerPremiumAfterIncentive,
    employerCostBeforeIncentive,
    employerCostAfterIncentive,
    totalPublicSupport: roundMoney(
      generalEmployerDiscount + researchEmployerSupport + incomeTaxIncentive + stampTaxIncentive
    ),
    nextTaxBase: roundMoney((Number(previousTaxBase) || 0) + taxBase),
    nextMinimumTaxBase: roundMoney((Number(previousMinimumTaxBase) || 0) + minimumTaxBase)
  };
}

function solveGrossForNet(targetNet, context) {
  const target = Math.max(0, Number(targetNet) || 0);
  if (!target) return 0;

  let low = target;
  let high = Math.max(target * 2, 100000);
  let guard = 0;
  while (calculatePayrollMonth({ ...context, gross: high }).net < target && guard < 24) {
    high *= 1.6;
    guard += 1;
  }

  for (let index = 0; index < 70; index += 1) {
    const middle = (low + high) / 2;
    const result = calculatePayrollMonth({ ...context, gross: middle });
    if (result.net < target) low = middle;
    else high = middle;
  }

  return roundMoney(high);
}

function calculatePayrollProjection({
  year,
  code,
  rows,
  education = "other",
  manufacturing = false,
  startingCumulativeTaxBase = 0
}) {
  let selectedTaxBase = Number(startingCumulativeTaxBase) || 0;
  let selectedMinimumTaxBase = 0;
  let baselineTaxBase = Number(startingCumulativeTaxBase) || 0;
  let baselineMinimumTaxBase = 0;

  const results = (rows || []).map((row, monthIndex) => {
    const common = {
      year,
      monthIndex,
      workDays: row.workDays,
      eligibleDays: row.eligibleDays,
      education,
      manufacturing
    };
    const selectedGross = row.type === "net"
      ? solveGrossForNet(row.amount, {
          ...common,
          code,
          previousTaxBase: selectedTaxBase,
          previousMinimumTaxBase: selectedMinimumTaxBase
        })
      : Number(row.amount) || 0;
    const baselineGross = row.type === "net"
      ? solveGrossForNet(row.amount, {
          ...common,
          code: "00000",
          previousTaxBase: baselineTaxBase,
          previousMinimumTaxBase: baselineMinimumTaxBase
        })
      : Number(row.amount) || 0;

    const selected = calculatePayrollMonth({
      ...common,
      gross: selectedGross,
      code,
      previousTaxBase: selectedTaxBase,
      previousMinimumTaxBase: selectedMinimumTaxBase
    });
    const baseline = calculatePayrollMonth({
      ...common,
      gross: baselineGross,
      code: "00000",
      previousTaxBase: baselineTaxBase,
      previousMinimumTaxBase: baselineMinimumTaxBase
    });

    selectedTaxBase = selected.nextTaxBase;
    selectedMinimumTaxBase = selected.nextMinimumTaxBase;
    baselineTaxBase = baseline.nextTaxBase;
    baselineMinimumTaxBase = baseline.nextMinimumTaxBase;

    return {
      monthIndex,
      monthName: MONTH_NAMES[monthIndex],
      type: row.type,
      enteredAmount: Number(row.amount) || 0,
      selected,
      baseline,
      employerSaving: roundMoney(Math.max(0, baseline.employerCostAfterIncentive - selected.employerCostAfterIncentive)),
      employeeNetAdvantage: roundMoney(Math.max(0, selected.net - baseline.net))
    };
  });

  const sum = (path) => roundMoney(results.reduce((total, row) => total + path(row), 0));
  return {
    rows: results,
    totals: {
      gross: sum((row) => row.selected.gross),
      net: sum((row) => row.selected.net),
      employeeDeductions: sum((row) => row.selected.employeeSocial + row.selected.employeeUnemployment),
      payableTax: sum((row) => row.selected.payableIncomeTax + row.selected.payableStampTax),
      employerCost: sum((row) => row.selected.employerCostAfterIncentive),
      baselineEmployerCost: sum((row) => row.baseline.employerCostAfterIncentive),
      employerSaving: sum((row) => row.employerSaving),
      publicSupport: sum((row) => row.selected.totalPublicSupport),
      incomeTaxIncentive: sum((row) => row.selected.incomeTaxIncentive),
      stampTaxIncentive: sum((row) => row.selected.stampTaxIncentive),
      sgkIncentive: sum((row) => row.selected.generalEmployerDiscount + row.selected.researchEmployerSupport)
    }
  };
}

function createDefaultPayrollRows(amount = 50000, type = "gross") {
  return MONTH_NAMES.map((monthName, monthIndex) => ({
    monthName,
    monthIndex,
    amount,
    type,
    workDays: 30,
    eligibleDays: 30
  }));
}

export {
  EDUCATION_OPTIONS,
  INCENTIVE_OPTIONS,
  MONTH_NAMES,
  OFFICIAL_SOURCES,
  PAYROLL_RULES,
  calculateMarginalTax,
  calculatePayrollMonth,
  calculatePayrollProjection,
  calculateProgressiveTax,
  createDefaultPayrollRows,
  solveGrossForNet
};
